import { useQuery } from "react-query";
import { PRICING_DETAILS_QUERY_KEYS } from "../constants/queryKeys";
import { getPricingDetailsList } from "../api/services/pricingDetails";

export const usePricingDetailsList = () => {
  const { data } = useQuery({
    queryKey: PRICING_DETAILS_QUERY_KEYS.list(),
    queryFn: () => getPricingDetailsList(),
  });

  const pricingMapping = data?.reduce((acc, plan) => {
    acc[plan.plan_type] = {
      monthly_price: plan.monthly_price,
      monthly_id: plan.id,
      annual_price: plan.annual_price,
      annual_id: plan.id,
      annual_discount: plan.annual_discount,
      monthly_annual_price: plan.monthly_annual_price,
      monthly_request_limit: plan.monthly_request_limit,
    };
    return acc;
  }, {});

  return {
    pricing: pricingMapping,
  };
};
